import { ChangeEvent, SyntheticEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import { addWordToDictionary } from "services/dictionary";
import { logError } from "services/logging";
import Dialog from "components/ui/Dialog";
import { GhostButton } from "components/adminUi/Button";
import Button from "components/ui/Button";
import Input from "components/formElements/Input/Input";
import "./SaveWords.css";

type AddNewWordDialogProps = {
  open: boolean;
  onClose: (refresh?: boolean) => void;
};

export const AddNewWordDialog = ({ open, onClose }: AddNewWordDialogProps) => {
  const { t } = useTranslation();
  const [word, setWord] = useState("");
  const [notes, setNotes] = useState("");

  const handleChangeWord = (e: ChangeEvent<HTMLInputElement>) => {
    setWord(e.target.value);
  };

  const handleChangeNote = (e: ChangeEvent<HTMLInputElement>) => {
    setNotes(e.target.value);
  };

  const handleSubmit = (event: SyntheticEvent) => {
    event.preventDefault();

    addWordToDictionary({
      word: word,
      notes: notes,
    })
      .then(() => onClose(true))
      .catch(logError);
  };

  // The kit ✕/Escape call this with no argument; the refresh flag is only
  // ever sent explicitly after a successful save.
  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      className="admin-form-dialog add-word"
      open={open}
      onClose={handleClose}
      closeOnOverlayClick={false}
      title={t("Tool.addNewWord")}
      footer={
        <>
          <GhostButton className="cancel" onClick={handleClose}>
            {t("Common.Cancel")}
          </GhostButton>
          <Button variant="primary" className="submit" onClick={handleSubmit}>
            {t("Tool.addNewWordBtn")}
          </Button>
        </>
      }
    >
      <div className="form-fields">
        <div className="width-100">
          <label htmlFor="word">{t("Tool.addNewWord")}</label>
        </div>
        <div className="width-100">
          <Input type="text" value={word} onChange={handleChangeWord} required={true} />
        </div>

        <div className="width-100">
          <label htmlFor="note">{t("Tool.addNote")}</label>
        </div>
        <div className="width-100">
          <Input type="text" value={notes} onChange={handleChangeNote} required={false} />
        </div>
      </div>
    </Dialog>
  );
};
